"use strict";
exports.__esModule = true;
exports.WebsdkQuotationHelperService = void 0;
var websdk_quotation_api_1 = require("./websdk-quotation.api");
var fetchQuotation = function (params) {
    return fetch(websdk_quotation_api_1.QuotationApi.get(params), { method: 'GET' }).then(function (res) { return res.json(); });
};
exports.WebsdkQuotationHelperService = { fetchQuotation: fetchQuotation };
//# sourceMappingURL=websdk-quotation-helper.service.js.map